import { gql } from '@apollo/client';
import { NSC_SUBJECT_DATA } from '../../fragments';

export const EXPORT_NSC_SUBJECT = gql`
  query ExportNSCSubjectData($input: ExportArgs!) {
    exportNSCSubjectData(input: $input) {
      id
      name
      focusSubjects {
        id
        name
      }
      grades {
        id
        name
        value
      }
      programme {
        id
        name
      }
      serviceProviders {
        id
        name
      }
      subjects {
        id
        name
        subjectGradeReference
      }
      nscSubjectData {
        ...nscSubjectData
      }
    }
  }
  ${NSC_SUBJECT_DATA}
`;
